<template>

  <div class="ekit-template-content-markup ekit-template-content-header ekit-template-content-theme-support">
    <div data-elementor-type="wp-post" data-elementor-id="13" class="elementor elementor-13"
      data-elementor-settings="[]">
      <div class="elementor-section-wrap">
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-c65d2ec elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="c65d2ec" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-ce605c0"
              data-id="ce605c0" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-46511db elementor-widget elementor-widget-image"
                  data-id="46511db" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container" style="cursor: pointer;" @click="$router.push('/')"> <img
                      style="height: 40px !important; vertical-align: middle;" src="/img/logo.png" /> <span style="color: white;
                    font-size: 32px;
                    font-weight: 400;
                    letter-spacing: 2px;
                    vertical-align: middle;
                    text-shadow: 3px 0 0 #ff2b2b;">Cyber</span><span style="color: white;
                    font-size: 32px;
                    font-weight: 400;
                    letter-spacing: 2px;
                    vertical-align: middle;
                    animation: animate 1.5s linear infinite;">Z</span></div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-db49c1a"
              data-id="db49c1a" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-1b5a3e3 elementor-widget elementor-widget-ekit-nav-menu"
                  data-id="1b5a3e3" data-element_type="widget" data-widget_type="ekit-nav-menu.default">
                  <div class="elementor-widget-container">
                    <div class="ekit-wid-con ekit_menu_responsive_tablet" data-hamburger-icon=""
                      data-hamburger-icon-type="icon" data-responsive-breakpoint="1024"> <button
                        class="elementskit-menu-hamburger elementskit-menu-toggler"> <span
                          class="elementskit-menu-hamburger-icon"></span><span
                          class="elementskit-menu-hamburger-icon"></span><span
                          class="elementskit-menu-hamburger-icon"></span> </button>
                      <div id="ekit-megamenu-header-menu"
                        class="elementskit-menu-container elementskit-menu-offcanvas-elements elementskit-navbar-nav-default elementskit_plus_icon ekit-nav-menu-one-page-no">
                        <ul id="menu-header-menu"
                          class="elementskit-navbar-nav elementskit-menu-po-center submenu-click-on-icon">
                          <li id="menu-item-30"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home page_item page-item-8 current_page_item menu-item-30 nav-item elementskit-mobile-builder-content"
                            :class="{'current-menu-item': $route.path == '/'}" data-vertical-menu=750px>
                            <a href="javascript:;" class="ekit-menu-nav-link">{{ $t('header.home') }}
                            </a>
                          </li>
                          <li onclick="jQueryScroll('#about-us')" id="menu-item-2893"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2893 nav-item elementskit-mobile-builder-content"
                            :class="{'current-menu-item': $route.path == '/about'}" data-vertical-menu=750px>
                            <a href="javascript:;" class="ekit-menu-nav-link">{{ $t('header.about') }}</a>
                          </li>
                          <li onclick="jQueryScroll('#services')" id="menu-item-2892"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2892 nav-item elementskit-mobile-builder-content"
                            data-vertical-menu=750px><a href="javascript:;" class="ekit-menu-nav-link">{{
                              $t('header.services') }}</a></li>
                          <li onclick="jQueryScroll('#products')" id="menu-item-2894"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2894 nav-item elementskit-mobile-builder-content"
                            data-vertical-menu=750px><a href="javascript:;" class="ekit-menu-nav-link">{{
                              $t('header.products')
                              }}</a></li>
                          <li onclick="jQueryScroll('#blog')" id="menu-item-2899"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2899 nav-item elementskit-mobile-builder-content"
                            data-vertical-menu=750px><a href="javascript:;" class="ekit-menu-nav-link">{{
                              $t('header.blog') }}</a>
                          </li>
                          <li id="menu-item-2899"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2899 nav-item elementskit-mobile-builder-content"
                            data-vertical-menu=750px>
                            <a v-if="$i18n.locale == 'vi'" @click="$root.$i18n.locale = 'en'" href="javascript:;"
                              class="ekit-menu-nav-link">English</a>
                            <a v-if="$i18n.locale == 'en'" @click="$root.$i18n.locale = 'vi'" href="javascript:;"
                              class="ekit-menu-nav-link">Tiếng Việt</a>
                          </li>
                          <!-- <li style="display: none;" id="menu-item-35"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-35 nav-item elementskit-dropdown-has relative_position elementskit-dropdown-menu-default_width elementskit-mobile-builder-content"
                            data-vertical-menu=750px><a href="#"
                              class="ekit-menu-nav-link ekit-menu-dropdown-toggle">More<i
                                class="icon icon-down-arrow1 elementskit-submenu-indicator"></i></a>
                            <ul class="elementskit-dropdown elementskit-submenu-panel">
                              <li id="menu-item-2898"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2898 nav-item elementskit-mobile-builder-content"
                                data-vertical-menu=750px><a href="/plan-pricing/" class=" dropdown-item">Plan &#038;
                                  Pricing</a></li>
                              <li id="menu-item-2896"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2896 nav-item elementskit-mobile-builder-content"
                                data-vertical-menu=750px><a href="/testimonials/"
                                  class=" dropdown-item">Testimonials</a></li>
                              <li id="menu-item-3809"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3809 nav-item elementskit-mobile-builder-content"
                                data-vertical-menu=750px><a href="/single-team/" class=" dropdown-item">Single
                                  Team</a></li>
                              <li id="menu-item-2897"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2897 nav-item elementskit-mobile-builder-content"
                                data-vertical-menu=750px><a href="/coming-soon/" class=" dropdown-item">Coming
                                  Soon</a></li>
                              <li id="menu-item-2895"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2895 nav-item elementskit-mobile-builder-content"
                                data-vertical-menu=750px><a href="/faq/" class=" dropdown-item">FAQ</a></li>
                            </ul>
                          </li> -->
                        </ul>
                        <div class="elementskit-nav-identity-panel">
                          <div class="elementskit-site-title"> <a class="elementskit-nav-logo" href="" target="_self"
                              rel=""> <img style="height: 40px !important; vertical-align: middle;"
                                src="/img/logo.png" /> <span style="color: white;
                            font-size: 32px;
                            font-weight: 400;
                            letter-spacing: 2px;
                            vertical-align: middle;">CyberZ</span> </a></div> <button
                            class="elementskit-menu-close elementskit-menu-toggler" type="button">X</button>
                        </div>
                      </div>
                      <div
                        class="elementskit-menu-overlay elementskit-menu-offcanvas-elements elementskit-menu-toggler ekit-nav-menu--overlay">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-c52f7da elementor-hidden-tablet elementor-hidden-mobile"
              data-id="c52f7da" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-777609a elementor-widget__width-auto elementor-widget elementor-widget-button"
                  data-id="777609a" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper"> <a href="javascript:;" onclick="jQueryScroll('#contact-us')"
                        class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                        role="button"> <span class="elementor-button-content-wrapper"> <span
                            class="elementor-button-text">{{ $t('header.contact_us') }}</span> </span> </a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeaderComponent',
    created() {
      window.jQueryScroll = elId => {
        jQuery('html, body').animate({
          scrollTop: jQuery(elId).offset().top
        }, 2000);
      }
    },
  }
</script>